// paneClickAway — whether a click outside a side pane should close it.
//
// MUI's ClickAwayListener counts a portal as inside only when it is a React
// child of the pane. Menus, dialogs and tooltips the page opens (the Quick
// Filter dialog, a name prompt, a model picker's list) are portals elsewhere in
// the tree, and a click in one must not close the pane. The Insights button
// toggles the pane itself: a click away there would close it and the button's
// own click open it again.

/** Where a click never closes the pane. */
export const PANE_CLICK_AWAY_EXEMPT = [
  '.MuiPopover-root',
  '.MuiMenu-root',
  '.MuiDialog-root',
  '.MuiModal-root',
  '[role="dialog"]',
  '[role="listbox"]',
  '[role="tooltip"]',
  '[data-insights-toggle]',
].join(', ')

export function shouldCloseOnClickAway(target: EventTarget | null): boolean {
  // A text node is judged by its element.
  const node = target as Node | null
  const el = node?.nodeType === 1 ? (node as Element) : node?.parentElement ?? null
  if (!el) return true
  return !el.closest(PANE_CLICK_AWAY_EXEMPT)
}
